<div class="wrap">
    <h1>Liste des infractions</h1>



    <!-- <table mat-table [dataSource]="dataSource" class="mat-elevation-z8">

        <ng-container matColumnDef="infraction_id">
            <th mat-header-cell *matHeaderCellDef> Id </th>
            <td mat-cell *matCellDef="let element"> {{element.infraction_id}} </td>
        </ng-container>

        <ng-container matColumnDef="camera">
            <th mat-header-cell *matHeaderCellDef> caméra </th>
            <td mat-cell *matCellDef="let element"> {{element.camera}} </td>
        </ng-container>

        <ng-container matColumnDef="video_stream">
            <th mat-header-cell *matHeaderCellDef> lien vidéo </th>
            <td mat-cell *matCellDef="let element"> {{element.video_stream}} </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>>
    </table> -->

</div>